import React from "react";
import { useTranslation } from "react-i18next";
import { Check, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SECTION_IDS } from "@/lib/navigation";

export const HowItWorks = () => {
  const { t } = useTranslation();
  const steps = t("how.steps", { returnObjects: true }) || [];
  const asideItems = t("how.aside_items", { returnObjects: true }) || [];

  return (
    <section
      id={SECTION_IDS.circuit}
      className="section-wash border-b border-border"
      data-testid="home-how-it-works"
    >
      <div className="container-page py-16 sm:py-20">
        <div className="max-w-3xl">
          <p className="eyebrow">{t("how.eyebrow")}</p>
          <h2 className="mt-4 text-2xl font-semibold leading-tight tracking-tight text-foreground sm:text-[34px]">
            {t("how.title")}
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-muted-foreground sm:text-base">
            {t("how.lead")}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
          <ol className="relative lg:col-span-7">
            <span
              className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-border"
              aria-hidden="true"
            />
            {steps.map((step, index) => (
              <li
                key={step.step}
                className="relative flex gap-5 pb-8 last:pb-0"
                data-testid={`how-step-${index}`}
              >
                <span className="font-data relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-border bg-card text-xs font-semibold text-[hsl(var(--deep-blue))]">
                  {step.step}
                </span>
                <div className="min-w-0 pt-1">
                  <h3 className="text-base font-semibold text-foreground">
                    {step.title}
                  </h3>
                  <p className="mt-2 max-w-xl text-sm leading-relaxed text-muted-foreground">
                    {step.text}
                  </p>
                </div>
              </li>
            ))}
          </ol>

          <aside className="lg:col-span-5">
            <div className="rounded-xl border border-border bg-card p-6">
              <h3 className="font-display text-base font-semibold text-foreground">
                {t("how.aside_title")}
              </h3>
              <ul className="mt-4 space-y-3">
                {asideItems.map((item) => (
                  <li key={item} className="flex items-start gap-2.5">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-[hsl(var(--terracotta))]" />
                    <span className="text-sm leading-relaxed text-muted-foreground">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
              <Button
                asChild
                variant="outline"
                className="mt-6 h-11 w-full rounded-lg border-border"
                data-testid="how-email-cta"
              >
                <a href="mailto:consultas@litiosur.com?subject=Consulta%20sobre%20la%20metodolog%C3%ADa%20Litiosur">
                  <Mail className="mr-2 h-4 w-4" />
                  {t("how.cta")}
                </a>
              </Button>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
